module.exports = __webpack_public_path__ + "img/kemter.dc9be192.png";